import { BROKERAGE_SCHWAB } from '../utils/constants';
import { apiRequest } from "../utils/apiClient";

const buildConnectionBody = (formData) => {
    const splitDate = new Date().toString().split(' ');
    const timezoneOffset = Number(splitDate[5].substring(3, 6));

    const body = {
        broker: BROKERAGE_SCHWAB,
        accountName: formData.accountName,
        autoConnect: formData.autoConnect,
        timezoneOffset,
        authorizationCode: formData.authorizationCode,
    };

    if (formData.buid) {
        body.buid = formData.buid;
    }

    if (formData.clientId) {
        body.clientId = formData.clientId;
    }

    if (formData.clientSecret) {
        body.clientSecret = formData.clientSecret;
    }

    return body;
};

export const getSchwabConnectUrl = async (params, userId, token) => {
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const queryParams = { uid: userId, ...params };
    return await apiRequest('get', null, '/api/v2/schwab/connect', {
        headers, params: queryParams,
    }, true);
};

export const connectToSchwab = async (formData, userId, token) => {
    const body = buildConnectionBody(formData);
    const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
    };
    const params = {
        uid: userId
    };
        try {
            return await apiRequest('post', '/algo/demo/data/start', '/api/v2/data/start', {
                headers, params, body,
            }, true);
        } catch (error) {
            console.log(error.message);
            alert("Error Connecting. Try Again");
            return error.message;
        }
};

export const disconnectFromSchwab = async (connectionName, buid, userId, token, formData, setFormData) => {
    const headers = {
        'Authorization': `Bearer ${token}`,
    };
    const params = {
        uid: userId,
        buid: buid
    };
    try {
        await apiRequest('get', '/algo/demo/data/stop', '/api/v2/data/stop', {
            headers, params,
        });

        setFormData(previousInputs => ({ ...previousInputs, isConnected: false }));
        //Find the item in the array to remove
        let accounts = [];
        for (let i = 0; i < formData.accountStatus.length; i++) {
            if (formData.accountStatus[i].name !== connectionName) {
                accounts.push(formData.accountStatus[i]);
            }
        }
        setFormData(previousInputs => ({ ...previousInputs, accountStatus: accounts }));
        alert(`You Have Removed Connection: ${connectionName}`);
    } catch (error) {
        console.log(error.message);
        alert("Error Removing Connection. Try Again");
        return error.message;
    }
};